<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	//Formatters
	import { format } from 'svelte-i18n';
	//Design system components
	import { Button, Container, Modal, Text, Icon } from '@Shelly/shelly-design-system';
	//Types
	import type { VirtualComponentInterface } from 'src/types/VirtualComponents';
	import { SystemScreenBreakpoints } from '@Shelly/shelly-design-system/helpers/enums';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';

	export let component: VirtualComponentInterface;
	export let showModal: boolean;
	export let waitForResponse = false;

	const dispatcher = createEventDispatcher();
	let windowClientWidth: number;

	$: isMobile = windowClientWidth < SystemScreenBreakpoints.MOBILE_MAX;
</script>

<svelte:window bind:innerWidth={windowClientWidth} />

<Modal
	{showModal}
	on:close={() => (showModal = false)}
	title={`${$format('button_delete', { default: 'Delete' })} ${$format('type_component')}?`}
>
	<svelte:fragment slot="content">
		<Container padding="0">
			<div class="d-flex flex-direction-column align-items-center">
				<Icon class="mb-xs" icon="text-danger fa-light fa-trash" size="xxl" />
				<Text class="text-bold text-center mb-s" styleType="controls-large">
					{component.config.name || component.key}
				</Text>
				<Text class="align-self-start">
					{$format('on_delete_component_msg', {
						values: {
							component_name: component.config.name || component.key,
						},
						default: 'Are you sure you want to delete the component ‘{component_name}’?',
					})}
				</Text>
			</div>
		</Container>
	</svelte:fragment>
	<div class="d-flex justify-content-end" slot="footer">
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
			responsiveSize={{
				sm: 'm',
			}}
			variant="secondary"
			on:click={() => (showModal = false)}
			>{$format('button_cancel', { default: 'Cancel' })}</Button
		>
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
			variant="danger"
			responsiveSize={{
				sm: 'm',
			}}
			loading={waitForResponse}
			on:click={() => dispatcher('remove', component)}
		>
			{$format('button_delete', { default: 'Delete' })}
			{$format('type_component', { default: 'Component' }).toLowerCase()}
		</Button>
	</div>
</Modal>
